import { Button, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@tellescope/ui";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical, X } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface SortableProductRowProps {
  rowKey: string;
  productId: string;
  options: { id: string; title: string }[];
  disableRemove: boolean;
  onChange: (newId: string) => void;
  onRemove: () => void;
}

export const SortableProductRow = ({
  rowKey,
  productId,
  options,
  disableRemove,
  onChange,
  onRemove,
}: SortableProductRowProps) => {
  const { t } = useTranslation("calendar");
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: rowKey });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} className="rounded-md flex items-center p-2 border gap-2 bg-background">
      <button
        type="button"
        className="cursor-grab touch-none text-muted-foreground hover:text-foreground focus:outline-none"
        {...attributes}
        {...listeners}
      >
        <GripVertical size={16} />
      </button>
      <Select value={productId} onValueChange={onChange}>
        <SelectTrigger className="grow">
          <SelectValue placeholder={t("Select product...")} />
        </SelectTrigger>
        <SelectContent>
          {options.map((product) => (
            <SelectItem key={product.id} value={product.id}>
              {product.title}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button variant="ghost" onClick={onRemove} disabled={disableRemove}>
        <X />
      </Button>
    </div>
  );
};
